module.exports = __webpack_public_path__ + "static/media/AlertaAnz.b9719635.png";